//V3

import "../style.css";
import React, { useContext, useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { roleAccess } from "../config/roleAccess";
import { getUserName, getCompanyInfo } from "../api";

function Header() {
  const { language, setLanguage } = useContext(LanguageContext);
  const { t } = useContext(LanguageContext);
  const navigate = useNavigate();

  const id_c = JSON.parse(localStorage.getItem("company"))?.id_c;
  const id_u = JSON.parse(localStorage.getItem("user"))?.id_u;
  const role = JSON.parse(localStorage.getItem("user"))?.rol || "Guest";

  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [userName, setUserName] = useState(null);
  const [companyName, setCompanyName] = useState(null);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!id_c || !id_u) return;
    getUserName(id_c, id_u).then(data => setUserName(data?.name_u));
    getCompanyInfo(id_c).then(data => setCompanyName(data?.name_c));
  }, [id_c, id_u]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setUserMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Rutas permitidas por rol
  const allowedPages = roleAccess[role] || [];
  const isAllowed = (key) => allowedPages.includes(key);

  // Mapa de rutas -> path y etiqueta (usa tus keys de i18n ya existentes)
  const pageConfig = {
    "1.home":            { path: "/1.home",            label: t("headin1") },     // Home
    "2.list2":           { path: "/2.list2",           label: t("headin2") },     // Informes
    "5.products1":       { path: "/5.products1",       label: t("headin4") },     // Productos
    "6.batches_temp":    { path: "/6.batches_temp",    label: t("batchList28")},     // Batches Temp
    "6.batches":         { path: "/6.batches",         label: t("headin6") },     // Batches
    "6.batches_report":  { path: "/6.batches_report",  label: t("headin6") },     // Reporte de Batches
    "shifts":            { path: "/shifts",            label: t("headin7") },     // Turnos
    "activityType":      { path: "/activityType",      label: t("actType1") },    // Tipos de actividad
    "batchRep":          { path: "/batchRep",          label: t("headin5")}, 
    "activityList":      { path: "/activityList",      label: t("actType9")},       
    "shift_report":      {path: "/shift_report",       label: t("headin7")},
    "operator_list":      {path: "/operator-list",     label: t("operator3")},
    "activity_report":   {path: "/activity_report",    label: t("actType9")},
    "oee_rep":            {path: "/oee_rep",           label: t("Oee1")},
    "activity_type_rep":  {path: "/activity_type_rep", label: t("atr_title")},
    "screen1":            {path: "/screen1",           label: t("screen1")},
    "screen_total":       {path: "/screen_total",      label: t("screen2")},
    "help":               {path: "/help",              label: t("help_menu")},
  };

  // Grupos del navbar
  const groups = [
    { // Home sin submenú
      key: "1.home",
      label: pageConfig["1.home"].label,
      path: pageConfig["1.home"].path,
    },
    {
      type: "dropdown",
      label: t("headin8") ,// Settings
      keys: ["shifts", "activityType", "5.products1","operator_list"],
    },
    {
      type: "dropdown",
      label: t("headin9") ,//Register
      keys: ["6.batches_temp","6.batches", "6.batches_report", "activityList","activity_report"],
    },
    {
      type: "dropdown",
      label: t("headin10") , //Reports
      keys: ["2.list2","batchRep","shift_report","oee_rep","activity_type_rep"],
    },
        {
      type: "dropdown",
      label: t("headin11") , //Screens
      keys: ["screen1", "screen_total"],
    },
  ];

  // Render helper para un dropdown si hay al menos un hijo permitido
  const renderDropdown = (label, keys) => {
    const items = keys.filter(isAllowed).map((k) => pageConfig[k]).filter(Boolean);
    if (items.length === 0) return null;

    return (
      <li className="nav-item dropdown" key={label}>
        <a
          className="nav-link dropdown-toggle web-nav-link"
          href="#"
          id={`dropdown-${label}`}
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {label}
        </a>
        <ul className="dropdown-menu" aria-labelledby={`dropdown-${label}`}>
          {items.map((cfg) => (
            <li key={cfg.path}>
              <Link className="dropdown-item" to={cfg.path}>
                {cfg.label}
              </Link>
            </li>
          ))}
        </ul>
      </li>
    );
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container-fluid">

        {/* Logo */}
        <Link className="navbar-brand" to="/">
          <img
            className="logo1"
            src="https://storage.googleapis.com/tt202501/images/techtalamo_logo2.jpg"
            alt="Logo"
          />
        </Link>

        {/* Botón móvil */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menú */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav">

            {/* Home (si el rol lo permite) */}
            {isAllowed("1.home") && (
              <li className="nav-item">
                <Link className="nav-link web-nav-link" to={pageConfig["1.home"].path}>
                  {pageConfig["1.home"].label}
                </Link>
              </li>
            )}

            {/* Configuración, Registro, Informes */}
            {groups
              .filter(g => g.type === "dropdown")
              .map(g => renderDropdown(g.label, g.keys))
            }


            {/* Exit */}
            <li className="nav-item">
              <button
                className="nav-link text-danger web-nav-link"
                onClick={() => {
                  localStorage.clear();
                  navigate("/");
                }}
              >
                {t("headin3")}
              </button>
            </li>
          </ul>

          {/* Selector de idioma + ícono ayuda — derecha */}
          <ul className="navbar-nav ms-auto">
            {isAllowed("help") && (
              <li className="nav-item d-flex align-items-center" style={{ marginRight: 10 }}>
                <Link
                  to="/help"
                  title={t("help_title")}
                  style={{ color: "#0a66c2", lineHeight: 1, opacity: 0.75, transition: "opacity 0.2s" }}
                  onMouseEnter={e => e.currentTarget.style.opacity = 1}
                  onMouseLeave={e => e.currentTarget.style.opacity = 0.75}
                >
                  <i className="bi bi-headset" style={{ fontSize: 20 }}></i>
                </Link>
              </li>
            )}
            <li className="nav-item d-flex align-items-center" style={{ gap: 2 }}>
              <button
                className="btn btn-link px-1 py-0"
                onClick={() => setLanguage("en")}
                style={{
                  fontWeight: language === "en" ? 700 : 400,
                  opacity: language === "en" ? 1 : 0.5,
                  textDecoration: "none",
                  color: "#0a66c2",
                  fontSize: 13,
                }}
              >EN</button>
              <span style={{ color: "#0a66c2", opacity: 0.4, fontSize: 13 }}>|</span>
              <button
                className="btn btn-link px-1 py-0"
                onClick={() => setLanguage("es")}
                style={{
                  fontWeight: language === "es" ? 700 : 400,
                  opacity: language === "es" ? 1 : 0.5,
                  textDecoration: "none",
                  color: "#0a66c2",
                  fontSize: 13,
                }}
              >ES</button>
            </li>
          </ul>
        </div>

        {/* User icon dropdown */}
        <div ref={menuRef} style={{ position: "relative", marginLeft: 12 }}>
          <button
            onClick={() => setUserMenuOpen(o => !o)}
            title={userName || ""}
            style={{
              background: "none", border: "none", cursor: "pointer", padding: "4px 6px",
              color: userMenuOpen ? "#0a66c2" : "#555",
              transition: "color 0.2s",
              lineHeight: 1,
            }}
            onMouseEnter={e => e.currentTarget.style.color = "#0a66c2"}
            onMouseLeave={e => { if (!userMenuOpen) e.currentTarget.style.color = "#555"; }}
          >
            <i className="bi bi-person-circle" style={{ fontSize: 26 }}></i>
          </button>

          {userMenuOpen && (
            <div style={{
              position: "absolute", right: 0, top: "calc(100% + 8px)",
              minWidth: 240, background: "#fff",
              borderRadius: 10, boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
              border: "1px solid rgba(0,0,0,0.08)",
              zIndex: 9000, overflow: "hidden",
            }}>
              {/* Header del panel */}
              <div style={{
                background: "#0a66c2", padding: "14px 16px",
                display: "flex", alignItems: "center", gap: 10,
              }}>
                <i className="bi bi-person-circle" style={{ fontSize: 32, color: "#fff" }}></i>
                <div>
                  <div style={{ color: "#fff", fontWeight: 700, fontSize: 14, lineHeight: 1.3 }}>
                    {userName || "—"}
                  </div>
                  <div style={{ color: "rgba(255,255,255,0.75)", fontSize: 12 }}>
                    {companyName || "—"}
                  </div>
                </div>
              </div>

              {/* Filas de info */}
              <div style={{ padding: "10px 0" }}>
                <div style={{
                  padding: "7px 16px", fontSize: 13, color: "#444",
                  display: "flex", justifyContent: "space-between", alignItems: "center",
                }}>
                  <span style={{ color: "#888", fontSize: 12 }}>{t("userInfo2") || "Rol"}</span>
                  <span style={{ fontWeight: 600 }}>{role}</span>
                </div>

                <div style={{ height: 1, background: "rgba(0,0,0,0.06)", margin: "4px 0" }} />

                <div style={{
                  padding: "7px 16px", fontSize: 13, color: "#444",
                  display: "flex", justifyContent: "space-between", alignItems: "center",
                }}>
                  <span style={{ color: "#888", fontSize: 12 }}>{t("userAccount1") || "Cuenta"}</span>
                  <span style={{
                    background: "#d1fae5", color: "#065f46",
                    fontWeight: 600, fontSize: 12,
                    padding: "2px 10px", borderRadius: 20,
                  }}>{t("userAccount2") || "Activa"}</span>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Header;

